(() => {
  const roots = document.querySelectorAll('[data-service-configurator]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => [...root.querySelectorAll(selector)];
    const locale = (root.dataset.locale || 'fr-CA').toLowerCase();
    const fr = locale.startsWith('fr');
    const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || root.dataset.rootUrl || '/';
    const productData = JSON.parse($('[data-product-json]')?.textContent || '{}');
    const gstRate = Number(root.dataset.gstRate || 0.05);
    const qstRate = Number(root.dataset.qstRate || 0.09975);
    const monthlyServiceCents = Number(root.dataset.monthlyServiceCents || 3000);
    const orderMode = (root.dataset.orderMode || 'checkout').toLowerCase();
    const productTitle = root.dataset.productTitle || productData.title || '5G Plus';

    const promoMarquee = document.querySelector('[data-promo-marquee]');

    const form = $('[data-service-form]');
    const checkoutButton = $('[data-checkout-button]');
    const checkoutConsent = $('[data-checkout-consent]');
    const checkoutError = $('[data-checkout-error]');
    const reviewStep = $('[data-step="review"]');
    const progressDock = $('[data-progress-dock]');
    const progressAction = $('[data-progress-action]');

    const eligibilityCard = $('[data-eligibility-card]');
    const addressInput = $('[data-address-input]');
    const addressSuggestions = $('[data-address-suggestions]');
    const addressCheckButton = $('[data-address-check]');
    const addressCheckLabel = $('[data-address-check-label]');
    const eligibilityProgress = $('[data-eligibility-progress]');
    const eligibilityPhase = $('[data-eligibility-phase]');
    const eligibilitySeconds = $('[data-eligibility-seconds]');
    const eligibilityBar = $('[data-eligibility-bar]');
    const eligibilityResult = $('[data-eligibility-result]');
    const eligibilityIcon = $('[data-eligibility-icon]');
    const eligibilityTitle = $('[data-eligibility-title]');
    const eligibilityCopy = $('[data-eligibility-copy]');
    const eligibilityContact = $('[data-eligibility-contact]');
    const contactModal = $('[data-contact-modal]');
    const contactForm = $('[data-contact-form]');
    const contactFirstName = $('[data-contact-first-name]');
    const contactLastName = $('[data-contact-last-name]');
    const contactPhone = $('[data-contact-phone]');
    const contactEmail = $('[data-contact-email]');
    const contactAddress = $('[data-contact-address]');
    const contactCloseButtons = $$('[data-contact-close]');
    const orderModal = $('[data-order-modal]');
    const orderForm = $('[data-order-modal] form');
    const orderCloseButtons = $$('[data-order-close]');
    const orderFirstName = $('[data-order-first-name]');
    const orderLastName = $('[data-order-last-name]');
    const orderProduct = $('[data-order-product]');
    const orderConfiguration = $('[data-order-configuration]');
    const orderAddress = $('[data-order-address]');
    const orderMonthly = $('[data-order-monthly]');
    const orderFee = $('[data-order-fee]');
    const orderBody = $('[data-order-body]');
    const orderPreviewConfiguration = $('[data-order-preview-configuration]');
    const orderPreviewAddress = $('[data-order-preview-address]');
    const orderSubmit = $('[data-order-submit]');
    const orderFormSuccess = $('[data-order-form-success]');
    const orderFormError = $('[data-order-form-error]');
    const lockedSteps = $$('[data-eligibility-locked]');

    const CHECK_DURATION_MS = 7000;
    const GOOD_NETWORK_RADIUS_KM = 5;
    const SITE_DATA_ENDPOINT = 'https://services.arcgis.com/wjcPoefzjpzCgffS/ArcGIS/rest/services/Spectrum_Licences_Site_Data/FeatureServer/0/query';

    let eligibilityPassed = false;
    let suggestionItems = [];
    let activeSuggestionIndex = -1;
    let selectedSuggestion = null;
    let suggestionTimer = null;
    let suggestionController = null;
    let eligibilityController = null;
    let animationFrame = null;

    const currency = new Intl.NumberFormat(fr ? 'fr-CA' : 'en-CA', {
      style: 'currency',
      currency: 'CAD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const msg = fr ? {
      addError: 'Impossible de préparer la commande. Veuillez réessayer.',
      unavailable: 'Cette option de configuration n’est pas disponible pour le moment.',
      addressRequired: 'Entrez une adresse canadienne avant de lancer la vérification.',
      addressNotFound: 'Nous n’avons pas trouvé cette adresse au Canada. Choisissez une suggestion ou vérifiez l’adresse.',
      searchError: 'Impossible d’effectuer la vérification pour le moment. Veuillez réessayer.',
      searchingSuggestions: 'Recherche d’adresses…',
      noSuggestions: 'Aucune suggestion trouvée au Canada.',
      checkingButton: 'Vérification en cours…',
      canada: 'Canada'
    } : {
      addError: 'We could not prepare the order. Please try again.',
      unavailable: 'This configuration option is currently unavailable.',
      addressRequired: 'Enter a Canadian address before starting the check.',
      addressNotFound: 'We could not find this address in Canada. Choose a suggestion or check the address.',
      searchError: 'We could not complete the check right now. Please try again.',
      searchingSuggestions: 'Searching addresses…',
      noSuggestions: 'No Canadian address suggestions found.',
      checkingButton: 'Checking…',
      canada: 'Canada'
    };

    function startPromoMarquee() {
      if (!promoMarquee) return;

      const viewport = promoMarquee.querySelector('.promo-marquee__viewport');
      const track = promoMarquee.querySelector('.promo-marquee__track');
      if (!viewport || !track) return;

      const durationSeconds = Math.max(4, Number(promoMarquee.dataset.marqueeSpeed || 18));
      let halfWidth = 0;
      let offset = 0;
      let lastTime = performance.now();
      let frameId = null;
      let paused = false;

      const measure = () => {
        halfWidth = track.scrollWidth / 2;
        if (!Number.isFinite(halfWidth) || halfWidth <= 0) halfWidth = 1;
        offset %= halfWidth;
      };

      const tick = (now) => {
        const delta = Math.min(64, Math.max(0, now - lastTime));
        lastTime = now;
        if (!paused && halfWidth > 1) {
          const pixelsPerMs = halfWidth / (durationSeconds * 1000);
          offset = (offset + delta * pixelsPerMs) % halfWidth;
          track.style.transform = `translate3d(${-offset}px,0,0)`;
        }
        frameId = requestAnimationFrame(tick);
      };

      const pause = () => { paused = true; };
      const resume = () => { paused = false; lastTime = performance.now(); };

      promoMarquee.addEventListener('mouseenter', pause);
      promoMarquee.addEventListener('mouseleave', resume);
      document.addEventListener('visibilitychange', () => {
        lastTime = performance.now();
      });
      window.addEventListener('resize', measure, {passive:true});

      measure();
      requestAnimationFrame(() => {
        measure();
        frameId = requestAnimationFrame(tick);
      });
    }

    function startPromoTimer() {
      if (!promoMarquee) return;

      const endTime = new Date(promoMarquee.dataset.promoEnd || '').getTime();
      if (!Number.isFinite(endTime)) return;

      const countdownEls = [...promoMarquee.querySelectorAll('[data-promo-countdown]')];
      let timerId = null;
      const pad = (number) => String(number).padStart(2, '0');

      const render = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const value = fr
          ? `${pad(days)}j ${pad(hours)}h ${pad(minutes)}min ${pad(seconds)}s`
          : `${pad(days)}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;

        countdownEls.forEach((el) => { el.textContent = value; });

        if (remaining <= 0) {
          promoMarquee.classList.add('is-ended');
          countdownEls.forEach((el) => { el.textContent = fr ? 'Offre terminée' : 'Offer ended'; });
          if (timerId) window.clearInterval(timerId);
        }
      };

      render();
      if (endTime > Date.now()) timerId = window.setInterval(render, 1000);
    }

    function selectedVariant() {
      const input = $('input[name="variant_id"]:checked');
      const id = Number(input?.value || 0);
      return (productData.variants || []).find((variant) => Number(variant.id) === id) || null;
    }

    function selectedVariantInput() {
      return $('input[name="variant_id"]:checked');
    }

    function selectChoice(input) {
      if (!input) return;
      $$(`input[name="${input.name}"]`).forEach((item) => {
        item.closest('[data-choice-card]')?.classList.toggle('is-selected', item.checked);
      });
    }

    function money(value) {
      return currency.format(Number(value || 0));
    }

    function updateSummary() {
      const input = selectedVariantInput();
      const variant = selectedVariant();
      const cents = Number(input?.dataset.priceCents || 0);
      const subtotal = cents / 100;
      const gst = subtotal * gstRate;
      const qst = subtotal * qstRate;
      const total = subtotal + gst + qst;
      const title = input?.dataset.variantTitle || variant?.title || '';

      const monthlyBase = monthlyServiceCents / 100;
      const monthlyGst = monthlyBase * gstRate;
      const monthlyQst = monthlyBase * qstRate;
      const monthlyTotal = monthlyBase + monthlyGst + monthlyQst;
      const isAssisted = cents > 0;

      $('[data-product-price-display]') && ($('[data-product-price-display]').textContent = money(subtotal));
      $('[data-summary-configuration-name]') && ($('[data-summary-configuration-name]').textContent = title);
      $('[data-summary-subtotal]') && ($('[data-summary-subtotal]').textContent = money(subtotal));
      $('[data-summary-gst]') && ($('[data-summary-gst]').textContent = money(gst));
      $('[data-summary-qst]') && ($('[data-summary-qst]').textContent = money(qst));
      $('[data-summary-total]') && ($('[data-summary-total]').textContent = money(total));

      $('[data-monthly-price-display]') && ($('[data-monthly-price-display]').textContent = money(monthlyBase));
      $('[data-summary-monthly-base]') && ($('[data-summary-monthly-base]').textContent = money(monthlyBase));
      $('[data-summary-monthly-base-row]') && ($('[data-summary-monthly-base-row]').textContent = money(monthlyBase));
      $('[data-summary-monthly-gst]') && ($('[data-summary-monthly-gst]').textContent = money(monthlyGst));
      $('[data-summary-monthly-qst]') && ($('[data-summary-monthly-qst]').textContent = money(monthlyQst));
      $('[data-summary-monthly-total]') && ($('[data-summary-monthly-total]').textContent = money(monthlyTotal));

      const assistedDetails = $('[data-assisted-details]');
      if (assistedDetails) assistedDetails.hidden = !isAssisted;
      const oneTimeTaxDetails = $('[data-one-time-tax-details]');
      if (oneTimeTaxDetails) oneTimeTaxDetails.hidden = !isAssisted;

      if (checkoutButton) checkoutButton.disabled = !eligibilityPassed || !variant || !variant.available || !checkoutConsent?.checked;
    }

    function setEligibilityLocked(locked) {
      eligibilityPassed = !locked;
      lockedSteps.forEach((step) => step.classList.toggle('is-disabled', locked));
      updateSummary();
    }

    function resetEligibilityResult() {
      setEligibilityLocked(true);
      if (eligibilityResult) {
        eligibilityResult.hidden = true;
        eligibilityResult.classList.remove('is-success', 'is-review', 'is-error');
      }
      if (eligibilityContact) eligibilityContact.hidden = true;
    }

    function showEligibilityResult(type, title, copy) {
      if (!eligibilityResult) return;
      eligibilityResult.hidden = false;
      eligibilityResult.classList.remove('is-success', 'is-review', 'is-error');
      eligibilityResult.classList.add(type === 'success' ? 'is-success' : type === 'review' ? 'is-review' : 'is-error');
      if (eligibilityIcon) eligibilityIcon.textContent = type === 'success' ? '✓' : '!';
      if (eligibilityTitle) eligibilityTitle.textContent = title || '';
      if (eligibilityCopy) eligibilityCopy.textContent = copy || '';
      if (eligibilityContact) eligibilityContact.hidden = type !== 'review';
    }

    function openContactModal() {
      if (!contactModal) return;
      if (contactAddress) contactAddress.value = addressInput?.value.trim() || selectedSuggestion?.address || '';
      contactModal.hidden = false;
      contactModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('contact-modal-open');
      window.setTimeout(() => contactFirstName?.focus(), 40);
    }

    function closeContactModal() {
      if (!contactModal) return;
      contactModal.hidden = true;
      contactModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('contact-modal-open');
      eligibilityContact?.focus();
    }

    function whatsappMessage() {
      const firstName = contactFirstName?.value.trim() || '';
      const lastName = contactLastName?.value.trim() || '';
      const phone = contactPhone?.value.trim() || '';
      const email = contactEmail?.value.trim() || '';
      const address = contactAddress?.value.trim() || addressInput?.value.trim() || '';

      if (fr) {
        return [
          'Bonjour, je souhaite faire vérifier mon adresse pour le service 5G à la maison.',
          '',
          'La pré-vérification en ligne n’a pas pu confirmer automatiquement la disponibilité du service à mon adresse.',
          '',
          `Prénom : ${firstName}`,
          `Nom : ${lastName}`,
          `Téléphone : ${phone}`,
          `Courriel : ${email}`,
          `Adresse à vérifier : ${address}`,
          '',
          'Pouvez-vous vérifier la disponibilité et me contacter afin de finaliser mon dossier? Merci.'
        ].join('\n');
      }

      return [
        'Hello, I would like to have my address checked for 5G et plus service.',
        '',
        'The online pre-check could not automatically confirm service availability at my address.',
        '',
        `First name: ${firstName}`,
        `Last name: ${lastName}`,
        `Phone: ${phone}`,
        `Email: ${email}`,
        `Address to verify: ${address}`,
        '',
        'Could you verify availability and contact me to finalize my file? Thank you.'
      ].join('\n');
    }

    function closeSuggestions() {
      if (!addressSuggestions) return;
      addressSuggestions.classList.remove('show');
      addressSuggestions.innerHTML = '';
      suggestionItems = [];
      activeSuggestionIndex = -1;
      addressInput?.removeAttribute('aria-activedescendant');
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[char]));
    }

    function photonLabel(feature) {
      const p = feature?.properties || {};
      const mainParts = [];
      if (p.housenumber) mainParts.push(p.housenumber);
      if (p.street) mainParts.push(p.street);
      else if (p.name) mainParts.push(p.name);
      const main = mainParts.join(' ').trim() || p.name || p.city || p.town || p.village || '';
      const sub = [p.city || p.town || p.village || p.municipality, p.state, p.postcode].filter(Boolean).join(', ');
      const full = [main, sub, p.country || msg.canada].filter(Boolean).join(', ');
      return {main, sub, full};
    }

    function renderSuggestions(features) {
      if (!addressSuggestions) return;
      suggestionItems = features;
      activeSuggestionIndex = -1;
      addressSuggestions.innerHTML = '';

      if (!features.length) {
        addressSuggestions.innerHTML = `<div class="suggestion-empty">${escapeHtml(msg.noSuggestions)}</div>`;
        addressSuggestions.classList.add('show');
        return;
      }

      features.forEach((feature, index) => {
        const labels = photonLabel(feature);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'address-suggestion';
        button.id = `EligibilitySuggestion-${root.dataset.sectionId}-${index}`;
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', 'false');
        button.innerHTML = `<span class="address-suggestion__pin">⌖</span><span><strong>${escapeHtml(labels.main)}</strong><span>${escapeHtml(labels.sub || msg.canada)}</span></span>`;
        button.addEventListener('mousedown', (event) => event.preventDefault());
        button.addEventListener('click', () => selectSuggestion(index));
        addressSuggestions.appendChild(button);
      });
      addressSuggestions.classList.add('show');
    }

    async function fetchAddressSuggestions(query) {
      if (!addressSuggestions) return;
      suggestionController?.abort();
      suggestionController = new AbortController();
      addressSuggestions.innerHTML = `<div class="suggestion-loading">${escapeHtml(msg.searchingSuggestions)}</div>`;
      addressSuggestions.classList.add('show');

      try {
        const params = new URLSearchParams({
          q: query,
          limit: '6',
          lang: fr ? 'fr' : 'en',
          bbox: '-141,41,-52,84'
        });
        const response = await fetch(`https://photon.komoot.io/api/?${params.toString()}`, {signal: suggestionController.signal});
        if (!response.ok) throw new Error('Suggestions unavailable');
        const data = await response.json();
        const features = Array.isArray(data.features) ? data.features.filter((feature) => {
          const cc = String(feature?.properties?.countrycode || '').toUpperCase();
          return !cc || cc === 'CA';
        }).slice(0, 6) : [];
        renderSuggestions(features);
      } catch (error) {
        if (error.name !== 'AbortError') closeSuggestions();
      }
    }

    function scheduleSuggestions() {
      clearTimeout(suggestionTimer);
      selectedSuggestion = null;
      resetEligibilityResult();
      const query = addressInput?.value.trim() || '';
      if (query.length < 3) {
        closeSuggestions();
        return;
      }
      suggestionTimer = setTimeout(() => fetchAddressSuggestions(query), 300);
    }

    function updateActiveSuggestion() {
      const buttons = addressSuggestions ? [...addressSuggestions.querySelectorAll('.address-suggestion')] : [];
      buttons.forEach((button, index) => {
        const active = index === activeSuggestionIndex;
        button.classList.toggle('active', active);
        button.setAttribute('aria-selected', String(active));
        if (active) {
          addressInput?.setAttribute('aria-activedescendant', button.id);
          button.scrollIntoView({block: 'nearest'});
        }
      });
    }

    function selectSuggestion(index) {
      const feature = suggestionItems[index];
      if (!feature || !addressInput) return;
      const labels = photonLabel(feature);
      const coordinates = Array.isArray(feature.geometry?.coordinates) ? feature.geometry.coordinates : [];
      selectedSuggestion = {
        address: labels.full.replace(/, Canada$/i, ''),
        lat: Number(coordinates[1]),
        lon: Number(coordinates[0])
      };
      addressInput.value = selectedSuggestion.address;
      closeSuggestions();
      resetEligibilityResult();
    }

    async function geocodeAddress(query, signal) {
      if (selectedSuggestion && selectedSuggestion.address === query && Number.isFinite(selectedSuggestion.lat) && Number.isFinite(selectedSuggestion.lon)) {
        return selectedSuggestion;
      }
      const params = new URLSearchParams({
        format: 'jsonv2',
        q: query,
        countrycodes: 'ca',
        addressdetails: '1',
        limit: '1',
        'accept-language': fr ? 'fr' : 'en'
      });
      const response = await fetch(`https://nominatim.openstreetmap.org/search?${params.toString()}`, {
        signal,
        headers: {'Accept': 'application/json'}
      });
      if (!response.ok) throw new Error('Geocoding unavailable');
      const results = await response.json();
      if (!Array.isArray(results) || !results.length) return null;
      const result = results[0];
      const lat = Number(result.lat);
      const lon = Number(result.lon);
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
      return {address: result.display_name || query, lat, lon};
    }

    function distanceKm(lat1, lon1, lat2, lon2) {
      const R = 6371;
      const toRad = (degrees) => degrees * Math.PI / 180;
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
      return 2 * R * Math.asin(Math.sqrt(a));
    }

    function searchEnvelope(lat, lon, radiusKm) {
      const latDelta = radiusKm / 110.574;
      const cosLat = Math.max(0.2, Math.cos(lat * Math.PI / 180));
      const lonDelta = radiusKm / (111.320 * cosLat);
      return {west: lon - lonDelta, south: lat - latDelta, east: lon + lonDelta, north: lat + latDelta};
    }

    async function checkNetworkAvailability(lat, lon, signal) {
      const envelope = searchEnvelope(lat, lon, GOOD_NETWORK_RADIUS_KM * 1.08);
      const providerName = 'Rogers';
      const providerFilter = `LICENSEE LIKE '%${providerName}%' OR LICENSEE LIKE '%${providerName.toUpperCase()}%'`;
      const params = new URLSearchParams({
        f: 'json',
        where: providerFilter,
        outFields: 'LICENSEE,LOCATION,PROV,LATITUDE,LONGITUDE',
        returnGeometry: 'false',
        returnDistinctValues: 'true',
        geometry: [envelope.west, envelope.south, envelope.east, envelope.north].join(','),
        geometryType: 'esriGeometryEnvelope',
        inSR: '4326',
        spatialRel: 'esriSpatialRelIntersects',
        resultRecordCount: '2000'
      });
      const response = await fetch(`${SITE_DATA_ENDPOINT}?${params.toString()}`, {signal});
      if (!response.ok) throw new Error('Network data unavailable');
      const data = await response.json();
      if (data.error) throw new Error(data.error.message || 'Network data error');

      const unique = new Map();
      const features = Array.isArray(data.features) ? data.features : [];
      features.forEach((feature) => {
        const attributes = feature.attributes || {};
        const siteLat = Number(attributes.LATITUDE);
        const siteLon = Number(attributes.LONGITUDE);
        if (!Number.isFinite(siteLat) || !Number.isFinite(siteLon)) return;
        const key = `${siteLat.toFixed(5)},${siteLon.toFixed(5)}`;
        if (unique.has(key)) return;
        unique.set(key, {distanceKm: distanceKm(lat, lon, siteLat, siteLon)});
      });

      const sites = [...unique.values()].sort((a, b) => a.distanceKm - b.distanceKm);
      return {
        available: sites.some((site) => site.distanceKm <= GOOD_NETWORK_RADIUS_KM),
        nearestDistanceKm: sites[0]?.distanceKm ?? null
      };
    }

    function stopEligibilityAnimation() {
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    function startEligibilityAnimation() {
      stopEligibilityAnimation();
      if (!eligibilityProgress) return;
      eligibilityProgress.hidden = false;
      const startedAt = performance.now();
      const phase1 = eligibilityCard?.dataset.phase1 || '';
      const phase2 = eligibilityCard?.dataset.phase2 || '';
      const phase3 = eligibilityCard?.dataset.phase3 || '';

      const tick = (now) => {
        const elapsed = Math.min(CHECK_DURATION_MS, now - startedAt);
        const ratio = elapsed / CHECK_DURATION_MS;
        const remaining = Math.max(0, Math.ceil((CHECK_DURATION_MS - elapsed) / 1000));
        if (eligibilityBar) eligibilityBar.style.width = `${Math.max(3, ratio * 100)}%`;
        if (eligibilitySeconds) eligibilitySeconds.textContent = String(remaining);
        if (eligibilityPhase) {
          eligibilityPhase.textContent = ratio < 0.34 ? phase1 : ratio < 0.72 ? phase2 : phase3;
        }
        if (elapsed < CHECK_DURATION_MS) animationFrame = requestAnimationFrame(tick);
      };
      animationFrame = requestAnimationFrame(tick);
    }

    function delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async function runEligibilityCheck() {
      const query = addressInput?.value.trim() || '';
      if (!query) {
        showEligibilityResult('error', fr ? 'Adresse requise' : 'Address required', msg.addressRequired);
        addressInput?.focus();
        return;
      }

      closeSuggestions();
      resetEligibilityResult();
      eligibilityController?.abort();
      eligibilityController = new AbortController();
      const {signal} = eligibilityController;
      const checkStartedAt = Date.now();

      if (addressCheckButton) {
        addressCheckButton.disabled = true;
        addressCheckButton.classList.add('loading');
      }
      if (addressCheckLabel) addressCheckLabel.textContent = msg.checkingButton;
      startEligibilityAnimation();

      const verificationPromise = (async () => {
        const location = await geocodeAddress(query, signal);
        if (!location) return {kind: 'not-found'};
        const coverage = await checkNetworkAvailability(location.lat, location.lon, signal);
        return {kind: coverage.available ? 'success' : 'review', location, coverage};
      })();
      const timedVerificationPromise = Promise.race([
        verificationPromise,
        delay(12000).then(() => { throw new Error('Eligibility check timed out'); })
      ]);

      try {
        const [result] = await Promise.all([timedVerificationPromise, delay(CHECK_DURATION_MS)]);
        stopEligibilityAnimation();
        if (eligibilityProgress) eligibilityProgress.hidden = true;

        if (result.kind === 'not-found') {
          showEligibilityResult('error', fr ? 'Adresse introuvable' : 'Address not found', msg.addressNotFound);
          return;
        }

        if (result.kind === 'success') {
          showEligibilityResult(
            'success',
            eligibilityCard?.dataset.successTitle || (fr ? 'Adresse compatible avec le service' : 'Address compatible with the service'),
            eligibilityCard?.dataset.successText || ''
          );
          setEligibilityLocked(false);
          window.setTimeout(() => $('[data-step="configuration"]')?.scrollIntoView({behavior: 'smooth', block: 'center'}), 500);
        } else {
          showEligibilityResult(
            'review',
            eligibilityCard?.dataset.reviewTitle || (fr ? 'Vérification technique requise' : 'Technical verification required'),
            eligibilityCard?.dataset.reviewText || ''
          );
          setEligibilityLocked(true);
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error(error);
        eligibilityController?.abort();
        const remainingWait = Math.max(0, CHECK_DURATION_MS - (Date.now() - checkStartedAt));
        if (remainingWait) await delay(remainingWait);
        stopEligibilityAnimation();
        if (eligibilityProgress) eligibilityProgress.hidden = true;
        showEligibilityResult('error', fr ? 'Vérification indisponible' : 'Check unavailable', msg.searchError);
        setEligibilityLocked(true);
      } finally {
        if (addressCheckButton) {
          addressCheckButton.disabled = false;
          addressCheckButton.classList.remove('loading');
        }
        if (addressCheckLabel) addressCheckLabel.textContent = eligibilityCard?.querySelector('[data-address-check-label]')?.dataset.defaultLabel || (fr ? 'Vérifier mon adresse' : 'Check my address');
      }
    }

    function orderDetails(variant) {
      const input = selectedVariantInput();
      const configurationTitle = input?.dataset.variantTitle || variant?.title || (fr ? 'Standard' : 'Standard');
      const configurationSubtotal = Number(variant?.price || 0) / 100;
      const configurationGst = configurationSubtotal * gstRate;
      const configurationQst = configurationSubtotal * qstRate;
      const configurationTotal = configurationSubtotal + configurationGst + configurationQst;
      const monthlyBase = monthlyServiceCents / 100;
      const address = addressInput?.value.trim() || selectedSuggestion?.address || '';

      return {
        configurationTitle,
        address,
        monthlyLabel: `${money(monthlyBase)}${fr ? '/mois avant taxes' : '/month before taxes'}`,
        feeLabel: `${money(configurationTotal)} ${fr ? 'taxes incluses' : 'taxes included'}`
      };
    }

    function populateOrderModal(variant) {
      if (!orderModal) return;
      const details = orderDetails(variant);
      if (orderProduct) orderProduct.value = productTitle;
      if (orderConfiguration) orderConfiguration.value = details.configurationTitle;
      if (orderAddress) orderAddress.value = details.address;
      if (orderMonthly) orderMonthly.value = details.monthlyLabel;
      if (orderFee) orderFee.value = details.feeLabel;
      if (orderPreviewConfiguration) orderPreviewConfiguration.textContent = details.configurationTitle;
      if (orderPreviewAddress) orderPreviewAddress.textContent = details.address || '—';
      if (orderBody) {
        orderBody.value = fr
          ? [
              'Nouvelle demande de commande 5G Plus',
              '',
              `Produit : ${productTitle}`,
              `Configuration : ${details.configurationTitle}`,
              `Adresse : ${details.address || 'Non précisée'}`,
              `Service Internet : ${details.monthlyLabel}`,
              `Frais de configuration : ${details.feeLabel}`,
              '',
              'Le client souhaite être contacté afin de finaliser son dossier et la mise en service.'
            ].join('\n')
          : [
              'New 5G Plus order request',
              '',
              `Product: ${productTitle}`,
              `Configuration: ${details.configurationTitle}`,
              `Address: ${details.address || 'Not provided'}`,
              `Internet service: ${details.monthlyLabel}`,
              `Configuration fee: ${details.feeLabel}`,
              '',
              'The customer would like to be contacted to finalize their file and service activation.'
            ].join('\n');
      }
    }

    function openOrderModal(variant) {
      if (!orderModal) return;
      populateOrderModal(variant);
      orderModal.hidden = false;
      orderModal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('contact-modal-open');
      document.body.classList.add('contact-modal-open');
      window.setTimeout(() => orderFirstName?.focus(), 80);
    }

    function closeOrderModal() {
      if (!orderModal) return;
      orderModal.hidden = true;
      orderModal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('contact-modal-open');
      document.body.classList.remove('contact-modal-open');
    }

    function goDirectlyToCheckout() {
      const variant = selectedVariant();
      if (!eligibilityPassed) {
        eligibilityCard?.scrollIntoView({behavior: 'smooth', block: 'center'});
        return;
      }
      if (!checkoutConsent?.checked) {
        checkoutConsent?.focus();
        return;
      }
      if (!variant) {
        checkoutError.textContent = msg.addError;
        checkoutError.classList.add('show');
        return;
      }
      if (!variant.available) {
        checkoutError.textContent = msg.unavailable;
        checkoutError.classList.add('show');
        return;
      }

      checkoutButton.disabled = true;
      checkoutButton.classList.add('loading');
      checkoutError.classList.remove('show');

      try {
        if (orderMode === 'contact') {
          openOrderModal(variant);
          checkoutButton.disabled = false;
          checkoutButton.classList.remove('loading');
          return;
        }

        const rootUrl = routesRoot.endsWith('/') ? routesRoot : `${routesRoot}/`;
        const checkoutUrl = `${rootUrl}cart/${Number(variant.id)}:1`;
        window.location.assign(checkoutUrl);
      } catch (error) {
        console.error(error);
        checkoutError.textContent = msg.addError;
        checkoutError.classList.add('show');
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('loading');
      }
    }

    $$('[data-choice-card] input').forEach((input) => {
      input.addEventListener('change', () => {
        selectChoice(input);
        updateSummary();
      });
    });

    addressInput?.addEventListener('input', scheduleSuggestions);
    addressInput?.addEventListener('focus', () => {
      if ((addressInput.value || '').trim().length >= 3 && suggestionItems.length) addressSuggestions?.classList.add('show');
    });
    addressInput?.addEventListener('keydown', (event) => {
      const open = addressSuggestions?.classList.contains('show') && suggestionItems.length;
      if (event.key === 'ArrowDown' && open) {
        event.preventDefault();
        activeSuggestionIndex = Math.min(activeSuggestionIndex + 1, suggestionItems.length - 1);
        updateActiveSuggestion();
      } else if (event.key === 'ArrowUp' && open) {
        event.preventDefault();
        activeSuggestionIndex = Math.max(activeSuggestionIndex - 1, 0);
        updateActiveSuggestion();
      } else if (event.key === 'Enter' && open && activeSuggestionIndex >= 0) {
        event.preventDefault();
        selectSuggestion(activeSuggestionIndex);
      } else if (event.key === 'Escape') {
        closeSuggestions();
      }
    });

    addressCheckButton?.addEventListener('click', runEligibilityCheck);
    eligibilityContact?.addEventListener('click', openContactModal);
    contactCloseButtons.forEach((button) => button.addEventListener('click', closeContactModal));
    orderCloseButtons.forEach((button) => button.addEventListener('click', closeOrderModal));
    orderForm?.addEventListener('submit', (event) => {
      const variant = selectedVariant();
      populateOrderModal(variant);
      if (!orderForm.checkValidity()) {
        event.preventDefault();
        orderForm.reportValidity();
        return;
      }
      if (orderSubmit) {
        orderSubmit.disabled = true;
        orderSubmit.classList.add('loading');
      }
    });
    contactForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!contactForm.checkValidity()) {
        contactForm.reportValidity();
        return;
      }
      const url = `https://wa.me/14382218852?text=${encodeURIComponent(whatsappMessage())}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (orderModal && !orderModal.hidden) closeOrderModal();
      else if (contactModal && !contactModal.hidden) closeContactModal();
    });
    document.addEventListener('click', (event) => {
      if (!root.contains(event.target) || !event.target.closest('.address-wrap')) closeSuggestions();
    });

    checkoutConsent?.addEventListener('change', updateSummary);

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      goDirectlyToCheckout();
    });

    progressAction?.addEventListener('click', () => {
      if (!eligibilityPassed) eligibilityCard?.scrollIntoView({behavior: 'smooth', block: 'center'});
      else reviewStep?.scrollIntoView({behavior: 'smooth', block: 'center'});
    });

    function updateProgressDock() {
      if (!progressDock || !reviewStep) return;
      progressDock.classList.toggle('show', window.scrollY > 320 && reviewStep.getBoundingClientRect().top > window.innerHeight * 0.72);
    }

    window.addEventListener('scroll', updateProgressDock, {passive: true});
    window.addEventListener('resize', updateProgressDock);

    if (addressCheckLabel) addressCheckLabel.dataset.defaultLabel = addressCheckLabel.textContent.trim();
    if (orderFormSuccess || orderFormError) {
      if (orderModal) {
        orderModal.hidden = false;
        orderModal.setAttribute('aria-hidden', 'false');
      }
    }
    setEligibilityLocked(true);
    selectChoice(selectedVariantInput());
    updateSummary();
    startPromoMarquee();
    startPromoTimer();
    updateProgressDock();
  });
})();
